import { combineReducers } from 'redux';

import data from './data';
import status from './status';
import ui from './ui';

const reducer = combineReducers({
  ui,
  data,
  status,
});

export type KioskReducer = ReturnType<typeof reducer>;

export default reducer;
